import { Box, Button, Card, Stack, Typography } from '@mui/material'
import { Add } from '@mui/icons-material'
import { IntegrationType } from '@/types/integrations'

type IntegrationTypeCardProps = {
  integrationType: IntegrationType
  onAdd: (integrationType: IntegrationType) => void
  added?: boolean
}

export default function IntegrationTypeCard({
  integrationType,
  onAdd,
  added,
}: IntegrationTypeCardProps) {
  const { name } = integrationType
  return (
    <Card
      sx={{
        px: 2,
        py: 1,
      }}
    >
      <Stack direction="row" alignItems="center" spacing={2}>
        <Box sx={{ flexGrow: 1 }}>
          <Typography>{name}</Typography>

          {/* We don't have descriptions yet, but we will add them at some point. */}
          {/* <Typography variant="caption" color="text.secondary">
            {description}
          </Typography> */}
        </Box>
        <Button
          variant="text"
          startIcon={added ? undefined : <Add />}
          disabled={added}
          onClick={() => {
            onAdd(integrationType)
          }}
        >
          {added ? 'Added' : 'Add'}
        </Button>
      </Stack>
    </Card>
  )
}
